import {
  useClientDefaultData,
  useInvoiceDefaultTemplate,
  useProjectDefaultBillingData
} from '~/modules/billing-invoicing/common/hooks';

export const useBillingDefaults = ({ availableToBillProject, client }) => {
  const { invoiceDefaultTemplate } = useInvoiceDefaultTemplate();

  const { clientDefaultData } = useClientDefaultData({ client });

  const projectsBillingSettingsById = useProjectDefaultBillingData({
    projectIds: [availableToBillProject?.id].filter(Boolean)
  });

  return {
    billingDefaults: {
      ...(clientDefaultData || {}),
      ...(clientDefaultData?.billingSettings || {}),
      ...(projectsBillingSettingsById[availableToBillProject?.id] || {})
    },
    invoiceDefaultTemplate,
    clientDefaultData
  };
};
